import './javascript/components/jquery';
// import './javascript/components/jquery-datepicker';
import './javascript/components/jquery-magnificpopup';
// import './javascript/components/jquery-parallax';
import './javascript/components/jquery-parsleyjs';
import './javascript/components/jquery-slick';
import './javascript/components/jquery-stickykit';
import './javascript/components/jquery-select2';
import './javascript/components/jquery-zoom';
import './javascript/components/bootstrap-modal';
import './javascript/components/bootstrap-popover';
import './javascript/components/bootstrap-tooltip';
import './javascript/components/google-map';
// import './javascript/components/jquery-ionrangeslider';
import './javascript/components/jquery-evo-calendar';
import './javascript/components/aos';
import './javascript/components/google-font';

import './javascript/commons/helpers';
import './javascript/commons/layout';

import './javascript/pages/faq';

import './styles/index.scss';
